import styled, { css } from 'styled-components';
import { Header } from '../TradeCard/ListTradeCard/Content/Styles';
import applyResponsiveVdpStyles from '../../_shared/helpers/applyResponsiveVdpStyles';

export const TrdIcon = styled.img`
  margin-right: 4px;
  margin-bottom: -3px;
`;

export const StyledTrdBox = styled(Header)`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  align-items: flex-end;
`;

const StyledTrdVdpLabelVariants = {
  mini: css`
    font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
    margin-top: -2px;
  `
};

const trdQuoteAvailableVariant = {
  hasQuote: css`
    font-size: ${({ theme }) => theme.FONT_SIZES.BASE_SIZE};
  `,
  noQuote: css`
    font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
    margin-top: -2px;
  `
};

const CommonTrdInfo = styled.span`
  align-items: flex-end;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  padding-right: 3px;
`;

export const StyledTrdInfoVdp = styled(CommonTrdInfo)`
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE_SIZE};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  ${props => trdQuoteAvailableVariant[props.variant]}
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledTrdVdpLabelVariants.mini,
      expanded: StyledTrdVdpLabelVariants.expanded
    })}
`;

export const StyledTrdInfo = styled(CommonTrdInfo)`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
`;
